import {
  getWhatsNewRoutine,
  getRecentWhatsNewRoutine,
  getWhatsNewStatusRoutine,
  markWhatsNewSeenRoutine,
} from './actions'
import { initialState } from './state'

export default function whatsNewReducer(state = initialState, action = {}) {
  switch (action.type) {
    case getWhatsNewRoutine.TRIGGER:
    case getRecentWhatsNewRoutine.TRIGGER:
    case getWhatsNewStatusRoutine.TRIGGER:
      return { ...state, loading: true }

    case getWhatsNewRoutine.SUCCESS:
      return { ...state, items: action.payload, loading: false, lastFetchedAt: Date.now() }

    case getRecentWhatsNewRoutine.SUCCESS:
      return {
        ...state,
        recent: Array.isArray(action.payload)
          ? action.payload
          : action.payload?.data || [],
        loading: false,
        recentLastFetchedAt: Date.now(),
      }

    case getWhatsNewStatusRoutine.SUCCESS:
      return { ...state, status: action.payload, loading: false }

    case markWhatsNewSeenRoutine.SUCCESS:
      return {
        ...state,
        status: { ...state.status, hasNew: false, shouldPopup: false },
      }

    case getWhatsNewRoutine.FAILURE:
    case getRecentWhatsNewRoutine.FAILURE:
    case getWhatsNewStatusRoutine.FAILURE:
      return { ...state, loading: false, error: action.payload }

    default:
      return state
  }
}
